import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
// Services
import { RevenueTypeInsertService } from '../../service/revenue-type-insert/revenue-type-insert.service';

@Component({
	selector: 'app-revenue-type-insert',
	templateUrl: './revenue-type-insert.component.html',
	providers: [
		RevenueTypeInsertService,
		HttpModule
	]
})
export class RevenueTypeInsertComponent implements OnInit {

	private token;
	revenueType: FormGroup;
	Descricao: string = "";
	statusRevenueType: boolean;
	public permissoes: any[] = [];

	constructor(fb: FormBuilder, private revenueTypeInsertService: RevenueTypeInsertService, private router: Router) {
		this.token = localStorage.getItem('yara.token');
		this.revenueType = fb.group({
			'Descricao': [null, Validators.compose([Validators.required, Validators.maxLength(120)])],
			'Ativo': ''
		});
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
	}

	addRevenueType(value: any) {
		console.log(value);
		this.revenueTypeInsertService.insertRevenueType(this.token, value).subscribe(result => {
			if (result.Success)
				this.router.navigateByUrl('/tipo-receita');

		}, error => {
			console.log(error);
			
		});
	}

	cancelInsertEdit() {
		this.router.navigateByUrl('/tipo-receita');
	}

}



// WEBPACK FOOTER //
// ./src/app/revenue-type/component/revenue-type-insert/revenue-type-insert.component.ts